import React from 'react';
import { LucideIcon } from 'lucide-react';
import { ResponsiveCardValue } from './ResponsiveCardValue';

export interface StatsCardProps {
  title: string;
  value: string;
  icon: LucideIcon;
  color: string;
  accent?: string;
  titleLong?: string;
  subValue?: string;
  tint?: string;
}

export function StatsCard({ title, value, icon: Icon, color, accent = 'border-l-emerald-600', titleLong, subValue }: StatsCardProps) {
  return (
    <div
      className={`overflow-hidden rounded-xl border border-zinc-200/90 bg-white shadow-[0_1px_3px_rgba(0,0,0,0.04)] transition-all duration-200 hover:-translate-y-0.5 hover:border-zinc-300 hover:shadow-[0_6px_20px_rgba(0,0,0,0.06)] dark:border-zinc-700 dark:bg-zinc-900 dark:hover:border-zinc-600 border-l-[3px] ${accent}`}
    >
      <div className="flex min-h-[5rem] items-stretch">
        <div className="min-w-0 flex-1 px-3.5 py-3.5 sm:px-4 sm:py-4">
          <p className="whitespace-nowrap text-[9px] font-semibold uppercase leading-tight tracking-[0.08em] text-zinc-500 dark:text-zinc-400 sm:hidden">{title}</p>
          {titleLong ? (
            <p className="hidden whitespace-nowrap text-[10px] font-semibold uppercase leading-tight tracking-[0.08em] text-zinc-500 dark:text-zinc-400 sm:block">{titleLong}</p>
          ) : (
            <p className="hidden whitespace-nowrap text-[10px] font-semibold uppercase leading-tight tracking-[0.08em] text-zinc-500 dark:text-zinc-400 sm:block">{title}</p>
          )}
          <ResponsiveCardValue
            value={value}
            subValue={subValue}
            className="mt-1 font-semibold text-zinc-950 dark:text-zinc-50"
            subClassName="text-zinc-500 dark:text-zinc-400"
          />
        </div>
        <div className="flex w-11 shrink-0 items-center justify-center border-l border-zinc-100 bg-zinc-50/80 dark:border-zinc-700/80 dark:bg-zinc-800/50 sm:w-12">
          <div className={`flex h-8 w-8 items-center justify-center rounded-lg bg-white shadow-sm ring-1 ring-zinc-200/60 dark:bg-zinc-900 dark:ring-zinc-600/60 sm:h-9 sm:w-9 ${color}`}>
            <Icon className="h-4 w-4 sm:h-[18px] sm:w-[18px]" />
          </div>
        </div>
      </div>
    </div>
  );
}
